<template>
  <div>
    <div v-if="!isPremium && isPremium !== null">
      <PatronCard :patron="patron" :feature="stickyFeature" />
    </div>
    <div class="combined-card">
      <b-tabs v-model="tabIndex" no-fade>
        <b-tab title="Messages">
          <StickyMessages :isPremium="isPremium" :patron="patron" />
        </b-tab>
        <b-tab title="Templates">
          <StickyTemplates :isPremium="isPremium" :patron="patron" />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { method } from "lodash";
import StickyMessages from "./StickyMessages.vue";
import StickyTemplates from "./StickyTemplates.vue";
import PatronCard from "@/views/oc/PatronCard";

export default {
  name: "StickyCombined",
  components: {
    StickyMessages,
    StickyTemplates,
    PatronCard,
  },
  data: function () {
    return {
      tabIndex: 0,
      isPremium: null,
      patron: null,
      stickyFeature: {
        icon: "fas fa-thumbtack",
        title: "Sticky Messages",
        tagline:
          "Pin a message to the bottom of a channel so it's the last thing every member sees, perfect for rules, links and reminders.",
        points: [
          "Stick any message to any channel",
          "Use rich embeds and TagScript variables",
          "Save and reuse templates across channels",
          "Auto-refresh as new messages come in",
        ],
      },
    };
  },
  methods: {
    async checkPremium() {
      const response = await this.axios.get(
        `/api/v1/servers/${this.$route.params.guild_id}/meta`
      );
      this.isPremium = response.data.is_vip;
      this.patron = response.data.user_has_premium;
      this.isPremium = Boolean(this.isPremium);
    },
  },
  created() {
    this.checkPremium();
  },
  beforeRouteUpdate() {
    this.checkPremium();
  },
};
</script>

<style>
.combined-card {
  border: 1px solid #23282c;
  border-radius: 0.25rem;
  margin-bottom: 100px;
}
</style>
